import { t as o } from "./to-object.js";
import { t as r } from "./to-absolute-index.js";
import { l as t } from "./length-of-array-like.js";
import { d as i } from "./delete-property-or-throw.js";
var a = Math.min,
  e = [].copyWithin || function (e, s) {
    var n = o(this),
      m = t(n),
      p = r(e, m),
      f = r(s, m),
      h = arguments.length > 2 ? arguments[2] : void 0,
      l = a((void 0 === h ? m : r(h, m)) - f, m - p),
      d = 1;
    for (f < p && p < f + l && (d = -1, f += l - 1, p += l - 1); l-- > 0;) f in n ? n[p] = n[f] : i(n, p), p += d, f += d;
    return n;
  };
export { e as a };